import { FormattedMessage } from 'react-intl';
import { NetworkStatus } from '@apollo/client';
import { useState } from 'react';

import ProductBookListItem from '../../components/ProductBookListItem';
import CardSection from '../../containers/CardSection';
import Box from '../../components/layout/Box';
import Text from '../../components/Text';
import Button from '../../components/Button';
import ListItem from '../../components/ListItem';
import Image from '../../components/Image';

const BookList = ({
  loading,
  items,
  limit,
  fetchMore,
  networkStatus,
  product,
  affiliateProducts,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleLoadMore = () => {
    setCurrentPage((prev) => prev + 1);

    fetchMore({
      variables: {
        pagination: {
          offset: items.length,
          limit,
        },
      },
    });
  };

  const fetchingMore = networkStatus === NetworkStatus.fetchMore;
  const hasNextPage = loading || currentPage * limit === items.length;

  return (
    <CardSection
      title={<FormattedMessage defaultMessage="Säljes begagnat" />}
      subtitle={
        items?.length === 0 && (
          <FormattedMessage defaultMessage="Tyvärr finns det inga inlägg för den här artikeln... " />
        )
      }
    >
      <Box
        className="flex-column flex-grow-1 flex-shrink-1"
        style={{ minWidth: 0, overflow: 'hidden' }}
      >
        {items?.map((book) => {
          return <ProductBookListItem key={book.id} book={book} />;
        })}

        {affiliateProducts?.length > 0 && (
          <Box className="flex-column mt-3">
            <Text style={{ fontSize: '0.8rem' }} color="darkGrayColor">
              Annons
            </Text>
            <Box
              backgroundColor="cardBackgroundColor"
              className="flex-column flex-grow-1 flex-shrink-1"
              style={{ minWidth: 0, overflow: 'hidden' }}
            >
              {affiliateProducts?.map((affiliateProduct) => {
                return (
                  <ListItem
                    className="py-2"
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.open(affiliateProduct.link)}
                    key={affiliateProduct.id}
                    after={
                      <Box
                        borderRadius={999}
                        backgroundColor="primaryColor"
                        className="px-2 py-1 me-2"
                      >
                        <Text
                          color="whiteColor"
                          style={{ fontSize: '0.8rem', fontWeight: '600' }}
                        >
                          Gå till butik
                        </Text>
                      </Box>
                    }
                    before={
                      <Box
                        style={{
                          borderRight: '1px solid #f5f5f5',
                          width: 80,
                        }}
                        className="justify-content-center flex-grow-1 flex-shrink-1"
                      >
                        <Image
                          backgroundColor="transparentColor"
                          source="https://kthbok-images.s3.eu-north-1.amazonaws.com/content/amazonse.png"
                          style={{
                            width: '90%',
                          }}
                        />
                      </Box>
                    }
                  >
                    <Box
                      className="flex-column"
                      style={{
                        marginLeft: 10,
                        minWidth: 0,
                        overflow: 'hidden',
                      }}
                    >
                      <Text variant="listItemTitle">{product.title}</Text>
                      {product?.author && (
                        <Text variant="listItemSubtitle">
                          av {product.author}
                        </Text>
                      )}
                    </Box>
                  </ListItem>
                );
              })}
            </Box>

            <Text
              className="mt-2"
              style={{
                fontSize: '0.8rem',
              }}
              color="darkGrayColor"
            >
              <FormattedMessage defaultMessage="Genom att köpa kurslitteratur via någon av våra förmedlade butiker när det begagnade utbudet är knapert så stöder du driften av hemsidan. Tack på förhand!" />
            </Text>
          </Box>
        )}
      </Box>

      {(fetchingMore || hasNextPage) && (
        <Box
          onClick={handleLoadMore}
          className="align-items-center w-100 justify-content-center my-3"
        >
          <Button isLoading={fetchingMore}>
            <FormattedMessage defaultMessage="Visa fler" />
          </Button>
        </Box>
      )}
    </CardSection>
  );
};

export default BookList;
